import { type BaseSchemes } from 'rete'
import { type AreaPlugin } from 'rete-area-plugin'
import { css } from '@emotion/react'

const backgroundStyles = css({
  display: 'table',
  zIndex: -1,
  position: 'absolute',
  top: '-320000px',
  left: '-320000px',
  width: '640000px',
  height: '640000px',
  backgroundColor: '#ffffff',
  opacity: 1,
  backgroundImage:
    'radial-gradient(#a4a4a4 1.55px, transparent 1.55px), radial-gradient(#d0d0d0 1.55px, #ffffff 1.55px)',
  backgroundSize: '62px 62px',
  backgroundPosition: '0 0, 31px 31px',
})

export function addCustomBackground<S extends BaseSchemes, K>(area: AreaPlugin<S, K>) {
  const background = document.createElement('div')
  background.setAttribute('style', backgroundStyles.styles)
  area.area.content.add(background)
}
